import LandingPageForm from "../components/LandingPageForm";

const EditLandingPage = () => {
  return (
    <div>
      <h2 className="mb-4 text-xl tracking-wider uppercase">
        Редактирай лендинг-страница
      </h2>
      <LandingPageForm />
    </div>
  );
};

export default EditLandingPage;
